<template>
	<span class="badge rounded-pill text-xs" :class="badgeClass" v-tooltip:left="badgeTooltip" v-if="info">{{ title }}</span>
	<span class="badge rounded-pill text-xs bg-gray-200" v-else>{{ customer_user?.status }}</span>
</template>

<script>
	import { computed, inject } from 'vue';
	import moment from 'moment';

	export default {
		props: {
			customer_user: Object
		},
		setup(props) {
			const $env = inject('$env');

			const info = computed(() => {
				if(props.customer_user?.status in $env.MODEL.CustomerUser.statuses) return $env.MODEL.CustomerUser.statuses[props.customer_user.status];
				else return null;
			});

			const badgeClass = computed(() => {
				let data = info.value?.class ?? '';

				if(props.customer_user?.status == 'contacted') {
					const daysPassed = moment().diff(props.customer_user.status_updated_at, 'days');

					if(props.customer_user.status_times == 1 && daysPassed >= 1) data+= ' border border-2 border-dashed border-danger';
					if(props.customer_user.status_times == 2 && daysPassed >= 3) data+= ' border border-2 border-dashed border-danger';
					if(props.customer_user.status_times == 3 && daysPassed >= 7) data+= ' border border-2 border-dashed border-danger';
					if(props.customer_user.status_times == 4 && daysPassed >= 15) data+= ' border border-2 border-dashed border-danger';
					if(props.customer_user.status_times >= 5) data+= ' border border-2 border-dashed border-danger';
				}

				return data;
			});

			const badgeTooltip = computed(() => {
				if(props.customer_user?.status == 'contacted') {
					const daysPassed = moment().diff(props.customer_user.status_updated_at, 'days');

					if(props.customer_user.status_times == 1 && daysPassed >= 1) return `Ya paso más de 1 día para el 2° contacto.`;
					if(props.customer_user.status_times == 2 && daysPassed >= 3) return `Ya pasaron más de 3 días para el 3° contacto.`;
					if(props.customer_user.status_times == 3 && daysPassed >= 7) return `Ya pasaron más de 7 días para el 4° contacto.`;
					if(props.customer_user.status_times == 4 && daysPassed >= 15) return `Ya pasaron más de 15 días para el 5° contacto.`;
					if(props.customer_user.status_times >= 5) return `Ya contactaste al cliente en más de 5 oportunidades, no se recomienda volver a contactar.`;
				}

				return info.value?.description;
			});

			const title = computed(() => {
				if(info.value && info.value?.ordinal !== false) return `${props.customer_user?.status_times}° ${info.value.ordinal}`;
				else if(info.value) return info.value.title;
				else return null;
			});

			return { info, badgeClass, badgeTooltip, title };
		}
	}
</script>